<mat-dialog-actions>

  <button class="mat-raised-button"
          (click)="close.emit()">
    {{'COMMON.CANCEL' | translate}}
  </button>

  <button class="mat-raised-button mat-primary ml-3" [disabled]="disabled"
          (click)="submit.emit()">
    {{getSubmitButtonTranslateKey() | translate}}
  </button>

</mat-dialog-actions>
